import React__default from 'react';
import { Skeleton, Typography, Button } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../DefaultIcon/index.js';
import { withSuspense } from '../withSuspense/index.js';
import { classes } from './styles.js';

/**
 * A component that displays a folder with a clickable title. The title can be optionally truncated.
 * @param {FormatTechnicalFolderProps} props - The properties for this component.
 * @returns {JSX.Element} The rendered component.
 */
var FormatTechnicalFolder = function (_a) {
    var folder = _a.folder, onFolderClick = _a.onFolderClick, truncateTitleLargerThan = _a.truncateTitleLargerThan, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    // If a maximum title length is provided and the title is longer, truncate the title.
    var truncatedTitle = folder.title && truncateTitleLargerThan && folder.title.length > truncateTitleLargerThan
        ? "".concat(folder.title.substring(0, truncateTitleLargerThan), "...")
        : folder.title;
    return (React__default.createElement(Typography, { variant: "caption", title: folder.title },
        React__default.createElement(Button, { variant: "text", disabled: !onFolderClick, onClick: function (e) {
                onFolderClick && onFolderClick(folder, e);
            }, className: clsx(classes.field, classes.folder), size: "small", startIcon: React__default.createElement(KIcon, { className: "fa-folder", sx: {
                    fontSize: "0.75em!important"
                } }) }, truncatedTitle)));
};
var FormatTechnicalFolder$1 = withSuspense(FormatTechnicalFolder, { LoadingComponent: Skeleton });

export { FormatTechnicalFolder$1 as default };
//# sourceMappingURL=FormatTechnicalFolder.js.map
